import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { HxErrorHandlerService, HxToastrService } from 'hx-component';
import { HxStorageInvoiceService } from 'hx-services';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-storage-rejected',
    templateUrl: './storage-invoices-confirm.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, TranslocoPipe]
})
export class StorageInvoicesConfirmComponent {
  @Input() storageInvoiceId: number;
  @Input() action: string;
  cancelReason: string;
  isLoading = {
    list: false,
    submit: false,
  };

  constructor(
    private toastr: HxToastrService,
    private errorService: HxErrorHandlerService,
    private modalInstance: NgbActiveModal,
    private storageInvoiceService: HxStorageInvoiceService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  dismissModal() {
    this.modalInstance.dismiss();
  }

  rejectStorageInvoice() {
    this.isLoading.submit = true;

    let url = this.storageInvoiceService.rejectInvoice(this.storageInvoiceId, this.cancelReason);

    if (this.action === 'cancel') {
      url = this.storageInvoiceService.cancelInvoice(this.storageInvoiceId, this.cancelReason);
    }

    url.subscribe(() => {
      this.toastr.success('hc.storageInvoice.' + this.action);
      this.isLoading.submit = false;
      this.dismissModal();
      this.router.navigate(['/storage/invoices'], {relativeTo: this.aRoute});
    }, err => {
      this.isLoading.submit = false;
      this.errorService.check(err.error);
    });
  }
}
